// Feature component for updating a case
import { useNavigate } from 'react-router-dom';

interface UpdateCaseProps {
  caseId: string;
  onSuccess?: () => void;
  onCancel?: () => void;
}

export function UpdateCase({ caseId, onSuccess }: UpdateCaseProps) {
  const navigate = useNavigate();

  const handleUpdate = async () => {
    try {
      // Navigate to the case details page
      navigate(`/case-management/${caseId}`);
      
      // Call onSuccess if provided
      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      console.error('Error navigating to case details:', error);
    }
  };

  return (
    <button 
      onClick={handleUpdate}
      className="flex items-center gap-1 text-blue-600 hover:text-blue-800 px-2 py-1 rounded-md hover:bg-blue-50"
      data-component-name="UpdateCase"
    >
      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
      </svg>
      <span>Update</span>
    </button>
  );
}
